import { Overlay, OverlayContainer, OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { EnvironmentProviders, importProvidersFrom, makeEnvironmentProviders } from '@angular/core';
import { ModalOverlay } from '@df/ui/modal/modal-overlay';
import { ModalOverlayContainer } from '@df/ui/modal/modal-overlay-container';
import { MODAL_SCROLL_STRATEGY_PROVIDER } from '@df/ui/modal/modal.service';

export function provideDfUiModal(): EnvironmentProviders {
    return makeEnvironmentProviders([
        MODAL_SCROLL_STRATEGY_PROVIDER,
        {
            provide: Overlay,
            useExisting: ModalOverlay
        },
        {
            provide: OverlayContainer,
            useExisting: ModalOverlayContainer
        },
        importProvidersFrom(OverlayModule, PortalModule)
    ]);
}
